import { useNavigate } from "react-router-dom";
import classes from "./FAQ.module.css";

const Faq = () => {
  const navigate = useNavigate();
  return (
    <section className={classes.section}>
      <p
        onClick={() => {
          navigate("/profile", { replace: true });
        }}
      >
        <i class="fa-solid fa-arrow-left"></i>
      </p>
      <h1 className={classes.title}>FAQs</h1>
      <div className={classes.faq}>
        <h1>Who Are We?</h1>
        {
          <p>
            Our Purpose is to influence people to drip and look good with ease
            and also to slay on their budget. We envision to be part of the
            modern fashion world with our brand to stay ahead fashion trends,
            innovations and latest technology and we aim to inspire the dream of
            a better life through innovation and improvement of fashion style.
          </p>
        }
      </div>
      <div className={classes.faq}>
        <h1>How do i make payment?</h1>
        {<p>You can pay on paystack with your CARD or by BANK TRANSFER</p>}
      </div>
      <div className={classes.faq}>
        <h1>What do I do after making payment?</h1>
        {
          <p>
            Ensure you entered your delivery address in the delivery form
            section. After payment is confirmed, you will receive a call from
            one of our representatives to confirm your order and immediately
            initiate your delivery!
          </p>
        }
      </div>
      <div className={classes.faq}>
        <h1>how do i get my order?</h1>
        {<p>we deliver nationwide using reliable logistics companies</p>}
      </div>
      <div className={classes.faq}>
        <h1>how long before i get my order delivered to me?</h1>
        {<p>Between 24-96hours</p>}
      </div>
      <div className={classes.faq}>
        <h1>Refund and exchange policies?</h1>
        {
          <p>
            for refund and exchange, item must be unworn, inaltered, free from
            damages, labels and tags must be unremoved, refund and exchange of
            item is only valid for 7days after you made the order. contact us
            @dcluxurious@gmail.com
          </p>
        }
      </div>
    </section>
  );
};

export default Faq;
